export { default } from '@adopted-ember-addons/ember-stripe-elements/components/stripe-card-number';
